"use client";

import { SimpleGrid } from "@mantine/core";
import { Button, Group, Modal, Stack, Text } from "@/components/ui/elements";
import { useGroupHomeNoteGuideModal } from "./_function";

type GroupHomeNoteGuideModalProps = {
  opened: boolean;
  onClose: () => void;
};

export function GroupHomeNoteGuideModal({
  opened,
  onClose,
}: GroupHomeNoteGuideModalProps) {
  const { setHideModal } = useGroupHomeNoteGuideModal();

  const handleConfirm = () => {
    // 永続的に非表示（一度確認したら今後表示しない）
    setHideModal(true);
    onClose();
  };

  const handleClose = () => {
    setHideModal(true);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      close={handleClose}
      centered
      size="lg"
      padding="xl"
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Stack gap="sm">
        {/* メインキャッチセクション（統合） */}
        <div
          style={{
            background: "linear-gradient(135deg, #e8f5e9 0%, #fff8e1 100%)",
            borderRadius: "16px",
            padding: "16px 12px",
            border: "1px solid #c8e6c9",
          }}
        >
          <Stack gap="sm" align="center">
            <Text
              fw={700}
              ta="center"
              style={{
                fontSize: "24px",
                color: "#2e7d32",
                lineHeight: 1.4,
              }}
            >
              🏠 グループホームのお仕事、
              <br />
              気になりませんか？
            </Text>
            <Text size="sm" ta="center" style={{ lineHeight: 1.7 }}>
              福祉未経験のケアリンク運営メンバーが
              <br />
              <span style={{ fontWeight: 600, color: "#e65100" }}>
                実際に現場で働いてきました！
              </span>
            </Text>
          </Stack>
        </div>

        {/* 魅力ポイントセクション（2列） */}
        <div
          style={{
            backgroundColor: "#fafafa",
            borderRadius: "12px",
            padding: "12px",
          }}
        >
          <Text size="sm" fw={600} mb="sm" style={{ color: "#424242" }}>
            📝 体験レポートでわかること
          </Text>
          <SimpleGrid cols={2} spacing="xs">
            <Group gap="xs" wrap="nowrap">
              <Text size="md">✅</Text>
              <Text size="sm">
                <strong>1日の流れ</strong>
              </Text>
            </Group>
            <Group gap="xs" wrap="nowrap">
              <Text size="md">✅</Text>
              <Text size="sm">
                <strong>業務内容</strong>
              </Text>
            </Group>
            <Group gap="xs" wrap="nowrap">
              <Text size="md">✅</Text>
              <Text size="sm">
                <strong>現場の雰囲気</strong>
              </Text>
            </Group>
            <Group gap="xs" wrap="nowrap">
              <Text size="md">✅</Text>
              <Text size="sm">
                <strong>未経験者の本音</strong>
              </Text>
            </Group>
          </SimpleGrid>
        </div>

        {/* CTAセクション */}
        <Stack gap="xs">
          <Button
            component="a"
            href="https://note.com/care_link/n/n0aeb9d4c06b3?sub_rt=share_sb"
            target="_blank"
            rel="noopener noreferrer"
            color="green"
            onClick={handleConfirm}
            size="lg"
            style={{
              width: "100%",
              height: "56px",
              fontSize: "17px",
              fontWeight: 700,
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(46, 125, 50, 0.35)",
              background: "linear-gradient(135deg, #43a047 0%, #2e7d32 100%)",
            }}
          >
            📖 体験レポートを読んでみる
          </Button>
        </Stack>

        {/* 閉じるボタンセクション */}
        <Group justify="center">
          <Button
            color="gray"
            onClick={handleConfirm}
            variant="subtle"
            size="sm"
          >
            今は読まない
          </Button>
        </Group>

        <Text ta="center" c="dimmed" size="xs">
          ※ このお知らせは一度のみ表示されます
        </Text>
      </Stack>
    </Modal>
  );
}
